import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WaterBodiesFormComponent } from './water-bodies-form.component';
import { WaterBodiesFormResolve } from './water-bodies-form.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      // {
      //   path: 'manage/admin/water-bodies/edit/:id',
      //   component: WaterBodiesFormComponent,
      //   resolve: {
      //     waterBodies: WaterBodiesFormResolve,
      //   },
      // },
      // {
      //   path: 'manage/admin/water-bodies/add',
      //   component: WaterBodiesFormComponent,
      //   resolve: {
      //     waterBodies: WaterBodiesFormResolve,
      //   },
      // },
    ]),
  ],
  exports: [RouterModule],
})
export class WaterBodiesFormRoutingModule {}
